import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tcShipmentLineDisabled',
  pure: true
})
export class ShipmentLineDisabledPipe implements PipeTransform {
  transform(
    lineId: string,
    delivery: any,
    processStatus: string,
    shipmentLinesIds: string[]
  ): boolean {
    // Check if line is already in shipment lines
    const isInShipmentLines = shipmentLinesIds.includes(lineId);

    // Check if delivery has a status that prevents selection
    const hasBlockingStatus = delivery?.status === 'ReadyToShip' ||
                             delivery?.status === 'Shipped' ||
                             delivery?.status === 'Delivered';

    // Check if order line has a process status that prevents selection
    const hasBlockingProcessStatus = processStatus === 'Cancelled' ||
                                    processStatus === 'Completed';

    // Check if delivery has a position assigned
    const hasNoPosition = delivery?.position === undefined;

    // Return true if the line should be disabled
    return !isInShipmentLines && (hasBlockingStatus || hasBlockingProcessStatus || hasNoPosition);
  }
}
